import { useQuery } from 'react-query';
import ThematicPackageService from '../services/thematicPackageService';
import { useQueryParams } from './atoms/query-params-hook';
import TraitThematicPackageService from '../services/traitThematicPackageService';

export function useGetThematicPackages(queryOptions = {}, filterOptions = {}) {
  const {
    page,
    setPage,
    limit,
    setLimit,
    sort,
    setSort,
  } = useQueryParams();

  const totalEntries = useQuery([ 'thematic-packages' ], () => {
    return ThematicPackageService.getTotalEntriesOfCollection({ ...filterOptions });
  });

  const queryKey = [ 'thematic-packages', { page, limit, sort, ...filterOptions }];
  const queryFn = () => { return ThematicPackageService.get({ page, limit, sort, ...filterOptions }); };

  const q = useQuery({
    queryKey,
    queryFn,
    ...queryOptions,
  });

  return {
    thematicPackages: q.data,
    thematicPackagesLoading: q.isLoading,
    thematicPackagesError: q.isError,
    count: totalEntries?.data,
    page,
    limit,
    setPage,
    setLimit,
    sort,
    setSort,
  };
}

export const useThematicPackage = (id) => {
  const {
    data: thematicPackage,
    isLoading: thematicPackageLoading,
  } = useQuery(
    [ 'thematic-packages', id ],
    () => { return ThematicPackageService.getById(id); },
  );

  const thematicPackageRoadmapStatus = thematicPackage?.roadmap_status;

  const {
    page,
    setPage,
    limit,
    setLimit,
    sort,
    setSort,
  } = useQueryParams();

  const traitsCount = useQuery([ 'traits-count', id ], () => {
    return TraitThematicPackageService.getTotalEntriesOfCollection({ thematicpackage_id: id });
  });

  const {
    data: traits,
    isLoading: traitsLoading,
  } = useQuery(
    [ 'traits', { thematicpackage_id: id, page, limit, sort }],
    () => { return TraitThematicPackageService.get({ page, limit, sort }); },
  );

  return {
    thematicPackage,
    thematicPackageLoading,
    thematicPackageRoadmapStatus,
    traits,
    traitsLoading,
    traitsCount,
    page,
    limit,
    setPage,
    setLimit,
    sort,
    setSort,
  };
};
